import { Button, Icon, Checkbox, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, TextField, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { ITableCommonToolbar, TableCommon } from '../../../shared/components/TableCommon';
import { TableLoading } from '../../../shared/components/TableLoading';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { HistoryLocation } from '../enum/HistoryLocation';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { NewsStatus } from '../enum/NewsStatus';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { InfluencerSpreadsheetModel, InfluencerSpreadsheetModelInitial } from '../../../Models/InfluencerSpreadSheetModel';
import { AxiosError, AxiosResponse } from 'axios';
import { getTableColumn } from '../../../shared/operators';
import { Action, Column, Options } from 'material-table';
import { TableEmpty } from '../../../shared/components/TableEmpty';
import { NewsOrigin } from '../../../shared/enum/NewsOrigin';
import { theme } from '../../../theme';
import InfluencerService from '../../../Services/InfluencerService';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import InfluencerClassificationFilters from '../components/InfluencerClassificationFilters';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { InfluencerAuxiliarModel, InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { ptBR } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { InfluencerContext } from '../../ClassificationInfluencer/NewsContext';
import InfluencerTextFilter from '../components/InfluencerTextFilter';
import InfluencerUrlFilter from '../components/InfluencerUrlFilter';
import { TableCommonWithValidate } from '../../../shared/components/TableCommonWithValidate';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { UploadLoading } from '../../../shared/components/UploadLoading';
import { InfluencerUploadResult } from './InfluencerUploadResult';
import { InfluencerUploadResultInitial, InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { InfluencerAutorizationResult } from './InfluencerAutorizationResult';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { BasicDialog } from '../../../shared/components/BasicDialog';
import { set } from 'date-fns';

export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1.5, 4),
        width: '100%',
        maxWidth: '1800px'
    },
    title: {
        margin: '20px 0px 32px'
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
}));

function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}

export default function InfluencerProfileClassification() {
    const classesInput = useInputStyles();
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const newsContext = React.useContext(InfluencerContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [resultUpload, setResultUpload] = React.useState<InfluencerUploadResultModel>(InfluencerUploadResultInitial);
    // const [news, setNews] = React.useState<InfluencerModel>({} as InfluencerModel);
    const [file, setFile] = React.useState<InfluencerModel | null>(null);



    const [historyType, setHistoryType] = React.useState<HistoryLocation>(HistoryLocation.PENDING);
    const [spreadsheets, setSpreadsheets] = React.useState<InfluencerSpreadsheetModel[]>([]);
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [filterDate, setFilterDate] = React.useState<Date | null>(null);
    const [filterRequestor, setFilterRequestor] = React.useState<number | null>();
    const [filterResponsavelReputacao, setFilterResponsavelReputacao] = React.useState<number | null>();
    const [filterStatus, setFilterStatus] = React.useState<number | null>();
    const [filterBrand, setFilterBrand] = React.useState<number | null>();
    const [filterArea, setFilterArea] = React.useState<number | null>();
    const [filterNomeInfluenciador, setFilterNomeInfluenciador] = React.useState<string>('');
    const [filterUrl, setFilterUrl] = React.useState<string>('');
    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);
    const [influencerDelete, setinfluencerDelete] = React.useState<InfluencerSpreadsheetModel>(InfluencerSpreadsheetModelInitial);
    const [modalRow, setModalRow] = React.useState<InfluencerModel | null>({} as InfluencerModel);
    const [modalRejectionRow, setModalRejectionRow] = React.useState<InfluencerModel | null>({} as InfluencerModel);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isModalRejectionOpen, setIsModalRejectionOpen] = React.useState(false);

    const [influencerValidacao, setinfluencerValidacao] = React.useState<InfluencerSpreadsheetModel>(InfluencerSpreadsheetModelInitial);
    const [loading, setLoading] = React.useState(true);
    const [refreshData, setRefreshData] = React.useState(0);

    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            if (historyType == HistoryLocation.PENDING) {
                InfluencerService.getInfluencersByClient(clientEnable.id_cliente)
                    .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                    .catch((error: AxiosError) => { homeContext.showError('', error); });

                InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                    .then((res: AxiosResponse) => {
                        setFiltersData(res.data);
                    })
                    .catch((error: AxiosError) => { homeContext.showError('', error); });

            } else
                setLoading(false);
        }
    }, [historyType, status, refreshData]);

    const setSpreadsheetsData = (data: InfluencerSpreadsheetModel[]) => {
        setSpreadsheets(data);

        if (filters !== null && spreadsheets) {
            setLoading(false);
        }
    };

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };


    const tableColumns: Column<InfluencerModel>[] = [
        {
            title: 'Data de Recebimento',
            field: 'dataRecebimento',
            type: 'datetime',
            align: 'left',
            filtering: false,
            dateSetting: { locale: 'pt-BR' },
            defaultSort: 'desc',
            cellStyle: { minWidth: '190px' }
        },
        // getTableColumn('Id', 'id', 'string', 'left', undefined, undefined, false),
        getTableColumn('Nome Solicitante', 'id_solicitante', 'string', 'left', undefined, undefined, false),
        getTableColumn('Responsável Reputação', 'responsavelReputacao', 'string', 'left', undefined, undefined, false),
        getTableColumn('Marca', 'marca', 'string', 'left', undefined, undefined, false),
        getTableColumn('Área', 'area', 'string', 'left', undefined, undefined, false),
        getTableColumn('Nome influenciador', 'nome', 'string', 'left', undefined, undefined, false),

    ];

    const pendingTableToolbarText: ITableCommonToolbar = {
        title: '   ',
        subtitle: ' '
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pendingTableActions: (Action<any> | ((rowData: any) => Action<any>))[] = [
        {
            icon: 'edit',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Classificar',
            onClick: (_, rowData: InfluencerModel) => {
                homeContext.setSpreadsheetId(rowData.id);
                newsContext.setNewsCurrentId(rowData.id);
                newsContext.setNews(rowData);
                // newsContext.s(rowData.id);
                homeContext.setPageLocation(PageLocation.INFLUENCER_CLASSIFICATION);
            }
        },
        rowData => ({
            icon: 'delete_outline',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Excluir inflcuenciador',
            onClick: (_, rowData: InfluencerSpreadsheetModel) => {
                setinfluencerDelete(rowData);
                setShowConfirmDelete(true);
            },
            disabled: rowData.newsByStatus != rowData.totalInfluencer,
            hidden: rowData.newsByStatus != rowData.totalInfluencer
        }),
    ];

    const pendingTableOptions: Options<InfluencerModel> = {
        filtering: true,
        actionsColumnIndex: -1,
        pageSizeOptions: [5, 10],
    };

    const toggleValidacao: (Action<any> | ((rowData: any) => Action<any>))[] = [
        rowData => ({
            icon: rowData.autorizado === 1 ? 'check_box' : 'check_box_outline_blank',
            // icon: rowData.validacao ? 'check_box' : 'check_box_outline_blank',
            onClick: (_, row) => {
                if (rowData.reprovado === 1) {
                    homeContext.showError('Este influenciador já está reprovado. Primeiro desreprove-o para poder autorizar.');
                    return;
                }

                if (rowData.autorizado) {
                    handleValidate(row);
                } else {
                    setIsModalOpen(true);
                    setModalRow(row);
                }
            },
        }),
    ];

    const toggleReprovado: (Action<any> | ((rowData: any) => Action<any>))[] = [
        rowData => ({
            icon: rowData.reprovado === 1 ? 'check_box' : 'check_box_outline_blank',
            onClick: (_, row) => {
                if (rowData.autorizado === 1) {
                    homeContext.showError('Este influenciador já está autorizado. Primeiro desautorize-o para poder reprovar.');
                    return;
                }

                if (rowData.reprovado) {
                    handleRejection(row);

                } else {
                    setIsModalRejectionOpen(true);
                    setModalRejectionRow(row);
                }
            },
        })
    ];

    const handleValidate = (row: any) => {
        setLoading(true);
        setIsModalOpen(false);
        const ignoreQuotaLimit = sessionStorage.getItem('ignoreQuotaLimit') === 'true';
        InfluencerService.putInfluencerValidate(row.id, clientEnable?.id_cliente, ignoreQuotaLimit, row.prazoEntrega)
            .then((res: AxiosResponse) => {
                // setSpreadsheetsData(res.data);
                // setResultUpload({ ...res.data, status: StatusResult.SUCCESS });
                setFile(res.data);
                if (res.data.autorizado !== 0) {
                    setRefreshData(prev => prev + 1);
                    homeContext.showSuccess('Operação realizada com sucesso!');
                    // setResultUpload({ ...res.data, row, status: StatusResult.SUCCESS });
                    // setStatus(StatusUpload.FINISH);
                }
                // setStatus(StatusUpload.FINISH);
            })
            .catch((error) => {
                const errorResponse: IErrorResponse = ErrorHelper(error);
                const property = error.data?.errors?.[0]?.property || 'campo desconhecido';
                setLoading(false);
                homeContext.showError('Erro ao reprovar influenciador', error);
                // setResultUpload({
                //     ...InfluencerUploadResultInitial,
                //     message: errorResponse.message,
                //     title: 'Exibir detalhes do problema',
                //     property: property,
                //     status: StatusResult.ERROR
                // });
                // setStatus(StatusUpload.FINISH);
            });
    };
    const handleRejection = (row: any) => {
        setLoading(true);
        setIsModalRejectionOpen(false);
        InfluencerService.putInfluencerReject(row.id, clientEnable?.id_cliente, row.observacaoRejeicao)
            .then(() => {
                // Dispara o useEffect para atualizar os dados da página
                setRefreshData(prev => prev + 1);
                homeContext.showSuccess('Operação realizada com sucesso!');
            })
            .catch((error) => {
                setLoading(false);
                homeContext.showError('Erro ao reprovar influenciador', error);
            });
    };
    const handleStartClassification = () => {
        // homeContext.setSpreadsheetId(resultUpload.id);
        // homeContext.setPageLocation(PageLocation.INFLUENCER_HISTORY);
    };

    const handleChangeModalRejection = (prop: keyof InfluencerModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setModalRejectionRow({ ...modalRejectionRow, [prop]: event.target.value });
    };

    const handleChangeDate = (prop: keyof InfluencerModel) =>
        (date: Date | null) => {
            if (date) {
                setModalRow(prevNews => {
                    if (!prevNews) return prevNews;
                    return {
                        ...prevNews,
                        [prop]: toBrasiliaISOString(date),
                        id: prevNews.id ?? 0, // Ensure required fields are set
                    };
                });
            }
        };

    const deleteInfluencer = () => {
        setShowConfirmDelete(false);
        setHistoryType(HistoryLocation.CLASSIFIED);
        setLoading(true);
        InfluencerSpreadsheetService.deleteInfluencersById(influencerDelete.id)
            .then(() => {
                //  window.location.reload();
                setHistoryType(HistoryLocation.PENDING);
            });
    };



    const setFilterNull = () => {
        setFilterDate(null);
        setFilterRequestor(undefined);
        setFilterStatus(undefined);
        setFilterBrand(undefined);
        setFilterArea(undefined);
        setFilterResponsavelReputacao(undefined);
        setFilterNomeInfluenciador('');
        setFilterUrl('');

        // Refaz a busca dos dados originais após limpar os filtros
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const getEmptyTable = (historyLocation: HistoryLocation, displayText: string) => {
        if (historyType == historyLocation && spreadsheets.length == 0 && !loading) {
            return (
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center">
                    <Grid item className={classes.emptyTable}>
                        <TableEmpty displayText={displayText} />
                    </Grid>

                </Grid>
            );
        }
    };

    const getFiltersInfluencers = () => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersByClient(clientEnable.id_cliente,
                {
                    data_hora_receipt: filterDate,
                    marca: filterBrand,
                    solicitante: filterRequestor,
                    area: filterArea,
                    responsavel_reputacao: filterResponsavelReputacao,
                    nome: filterNomeInfluenciador,
                    url: filterUrl,
                }
            )
                .then((res: AxiosResponse) => {
                    if (res.data.length == 0) {
                        setSpreadsheetsData([]);
                    }
                    else {
                        setSpreadsheetsData(res.data);
                    }
                    setSpreadsheetsData(res.data);
                })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const inputTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        Listagem de Influenciadores
                    </Typography>
                </Grid>
                {/* <Grid
                        item
                        xs={12}
                    >
                        <Typography variant="body1">
                            Para incluir um novo perfil, insira os dados solicitados abaixo
                        </Typography>
                    </Grid> */}
            </Grid>
        );
    };

    const inputObservacoesRejeicao = () => {
        return (
            <Grid container spacing={2} style={{ minWidth: 350, padding: 8, }}>
                <Grid item xs={12} style={{ textAlign: 'center', marginBottom: 8 }}>
                    <TextField
                        label="Observações"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={modalRejectionRow?.observacaoRejeicao ?? ''}
                        onChange={handleChangeModalRejection('observacaoRejeicao')}
                    />
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        style={{ minWidth: 120 }}
                        onClick={() => setIsModalRejectionOpen(false)}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ minWidth: 140 }}
                        onClick={() => handleRejection(modalRejectionRow)}
                        disabled={!modalRejectionRow?.observacaoRejeicao}
                    >
                        Validar
                    </Button>
                </Grid>
            </Grid>
        );
    };

    const inputPrazodeEntrega = () => {
        return (
            <Grid container spacing={2} style={{ minWidth: 350, padding: 8, }}>
                <Grid item xs={12} style={{ textAlign: 'center', marginBottom: 8 }}>
                    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <DatePicker
                            id="news-date"
                            variant="dialog"
                            value={modalRow?.prazoEntrega ?? null}
                            inputVariant="outlined"
                            label="Prazo de Entrega"
                            minDate={new Date(0)}
                            onChange={handleChangeDate('prazoEntrega')}
                            InputProps={{
                                style: { background: '#fafafa' },
                            }}
                            format="dd/MM/yyyy"
                            style={{ width: '100%', maxWidth: 320 }}
                            fullWidth
                            autoOk
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        style={{ minWidth: 120 }}
                        onClick={() => setIsModalOpen(false)}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ minWidth: 140 }}
                        onClick={() => handleValidate(modalRow)}
                        disabled={!modalRow?.prazoEntrega}
                    >
                        Validar
                    </Button>
                </Grid>
            </Grid>
        );
    };


    return (
        <>
            {status === StatusUpload.INPUT && (
                <>
                    <Grid container justify="center">
                        <Grid
                            container
                            className={classes.root}
                            justify="flex-start"
                            direction="column">
                            {filters && (
                                <>
                                    <Grid
                                        container
                                        className={classes.root}
                                        direction="column"
                                    >
                                        {inputTitleAndSubtitle()}
                                        <Paper
                                            style={{
                                                borderRadius: '8px',
                                                width: '100%',
                                                // overflowX: 'auto'
                                            }}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                className={classes.root}
                                                spacing={4}
                                            >
                                                <Grid item
                                                    style={{
                                                        outline: 'none',
                                                        borderBottom: 'none',
                                                    }}
                                                >


                                                    <Grid container style={{ marginTop: '0.5rem', marginBottom: '0.5rem', border: '1px solid #ccc', padding: '8px', borderRadius: '4px' }}>
                                                        <Grid item xs={9}>
                                                            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                                                                <DatePicker
                                                                    id="news-date"
                                                                    variant="inline"
                                                                    value={filterDate}
                                                                    inputVariant="standard"
                                                                    label="Data de Recebimento"
                                                                    minDate={new Date(0)}
                                                                    onChange={(date) => setFilterDate(date ?? null)}
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                    }}
                                                                    format="dd/MM/yyyy"
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </Grid>
                                                        <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <Button onClick={() => setFilterDate(null)} variant="text" fullWidth style={{ height: '100%' }}
                                                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                            >
                                                                <Icon>delete_outline</Icon>
                                                            </Button>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                                <InfluencerClassificationFilters size={3} key={filterRequestor} items={filters.solicitantes} Title={'Nome Solicitante'} selectValue={filterRequestor} setSelectValue={setFilterRequestor} />
                                                <InfluencerClassificationFilters size={3} key={filterBrand} items={filters.marcas} Title={'Marca'} selectValue={filterBrand} setSelectValue={setFilterBrand} />
                                                <InfluencerClassificationFilters size={3} key={filterArea} items={filters.area} Title={'Área'} selectValue={filterArea} setSelectValue={setFilterArea} />
                                                <InfluencerClassificationFilters size={3} key={filterResponsavelReputacao} items={filters.responsavel_reputacao}
                                                    Title={'Responsável Reputação'} selectValue={filterResponsavelReputacao} setSelectValue={setFilterResponsavelReputacao} />
                                                <InfluencerTextFilter size={3} titulo='Nome Influenciador' value={filterNomeInfluenciador} setValue={setFilterNomeInfluenciador} />
                                                <InfluencerUrlFilter url={filterUrl} size={3} setUrl={setFilterUrl} titulo="URL" />

                                            </Grid>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                            >
                                                <Button
                                                    size="large"
                                                    variant="contained"
                                                    color="inherit"
                                                    style={{
                                                        width: '180px',
                                                        margin: '20px',
                                                    }}
                                                    onClick={() => setFilterNull()}
                                                >
                                                    Limpar Filtros
                                                </Button>

                                                <Button
                                                    size="large"
                                                    variant="contained"
                                                    color="primary"
                                                    style={{
                                                        width: '180px',
                                                        margin: '20px',
                                                    }}
                                                    onClick={getFiltersInfluencers}
                                                >Buscar</Button>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <BasicDialog
                                        open={isModalOpen}
                                        handleClose={() => setIsModalOpen(false)}
                                        title={'Definir Prazo de Entrega'}
                                        description="Por favor, informe o prazo de entrega para o influenciador selecionado."
                                        children={inputPrazodeEntrega()} />
                                    <BasicDialog
                                        open={isModalRejectionOpen}
                                        handleClose={() => setIsModalRejectionOpen(false)}
                                        title={'Observações'}
                                        description="Explique o motivo da reprovação deste influenciador."
                                        children={inputObservacoesRejeicao()} />
                                </>
                            )}
                            {spreadsheets.length > 0 && !loading && (
                                <>
                                    <Grid
                                        container
                                        className={classes.root}
                                        direction="column"
                                    >
                                        <TableCommonWithValidate
                                            tableData={spreadsheets}
                                            tableColumns={tableColumns}
                                            emptyDataSourceMessage='Nenhum influenciador encontrado para esse filtro.'
                                            tableActions={pendingTableActions}
                                            toolbar={pendingTableToolbarText}
                                            validationActions={toggleValidacao}
                                            rejectionActions={toggleReprovado}
                                            style={{ padding: theme.spacing(0, 11) }} />
                                    </Grid>
                                </>

                            )}
                            {loading &&
                                <TableLoading displayText="Carregando..." />}

                            {!loading && getEmptyTable(HistoryLocation.PENDING, 'Nenhum influenciador encontrado.')}
                        </Grid>
                    </Grid>
                    <BasicConfirmDialog
                        title={'Tem certeza que deseja excluir?'}
                        description={
                            influencerDelete && influencerDelete.newsOrigin == NewsOrigin.SpreadsheetImport
                                ? 'Ao excluir este Influenciador você não poderá classifica-lo.'
                                : 'Ao excluir este Influenciador você não poderá classifica-lo.' +
                                'não será possível obtê-lo novamente.'}
                        handleFirstButton={deleteInfluencer}
                        handleSecondButton={() => setShowConfirmDelete(false)}
                        textFirstButton={'Excluir'}
                        textSecondButton={'Cancelar'}
                        open={showConfirmDelete} />
                </>
            )}
            {status === StatusUpload.FINISH && (
                <InfluencerAutorizationResult
                    nameFile={file?.nome ?? ''}
                    result={resultUpload}
                    hasHistoryButton={authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Classificação de influencers') !== -1}
                    onClickHistory={() => homeContext.setPageLocation(PageLocation.INFLUENCER_CLASSIFICATION)}
                    onClickStartClassification={() => { setStatus(StatusUpload.INPUT); }}
                    onClickNewUpload={() => { handleValidate(resultUpload.row); }} />)}
        </>
    );


}